import { Label as SemanticLabel } from "semantic-ui-react";

import styles from "./BaseLabel.module.scss";
import cn from "classnames";
import { type PropsWithChildren } from "react";

export type Color = "yellow" | "blue" | "black" | "green" | "darker-green" | "gray" | "green-accent" | "red-accent";
export type Attached = "left" | "right";

export interface BaseLabelProps extends PropsWithChildren {
  color?: Color;
  className?: string;
  attached?: Attached;
  basic?: boolean;
}

export const BaseLabel = ({ color = "black", children, className, attached, basic }: BaseLabelProps) => {
  return (
    <div
      className={cn(
        styles.root,
        styles[color],
        className,
        { [styles.attached]: !!attached },
        attached ? styles[attached] : undefined,
      )}
    >
      <SemanticLabel className={styles.label} basic={basic}>
        {children}
      </SemanticLabel>
    </div>
  );
};
